import React, {useEffect, useRef, useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {Col} from "react-bootstrap";
import {useHistory, useParams} from "react-router-dom";
import {Actions} from "../../../client/Actions";
import FormatData from "./FormatData";
import CustomAccordion from "../../components/accordion/CustomAccordion";
import MachineStep from "./MachineStep";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import {FormatHeader} from "./FormatHeader";
import {hasFormatsFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';


const FormatPage = (props) => {
    let {id} = useParams();
    let history = useHistory();

    const { t } = useTranslation();

    const models = useModels();

    const [loader, setLoader] = useState(false);
    const [activeKey, setActiveKey] = useState();
    const [formatId, setFormatId] = useState(id);
    const [completedProcesses, setCompletedProcesses] = useState();
    const [format, setFormat] = useState();
    const [reload, setReload] = useState();
    const [confirmed, setConfirmed] = useState(false)


    const dataRef = useRef(null);
    const machinesRef = useRef(null);

    const [scrollTarget, setScrollTarget] = useState(null);

    const isNewFormat = () => {
        return !id;
    };

    const prepareFormatId = () => {
        if (isNewFormat()) {
            if (!hasFormatsFullAccess()) {
                history.push("/formats")
            }
            Actions.get("format/generate", setFormatId);
        }
    };

    const loadFormat = () => {
        if (formatId && !isNewFormat()) {
            Actions.get("format/" + formatId, setFormat)
        }
    };

    const onSavedFormat = () => {
        history.push("/format/" + formatId)
    };

    const calculateCompletedProcesses = () => {
        if (isNewFormat() && !completedProcesses) {
            setCompletedProcesses({
                data: false,
                machines: false,
            });
        } else if (format) {
            setCompletedProcesses({
                data: true,
                machines: format.formatStatus && format.formatStatus !== "CONFIGURATION",
            });
        }
    };

    const determineCurrentActiveKey = () => {
        if (completedProcesses) {
            if (!completedProcesses.data) {
                setActiveKey("data");
            } else if (!completedProcesses.machines) {
                setActiveKey("machines");
            }
        }
    };

    const scrollToAccordionItem = (key) => {
        const refs = {
            data: dataRef,
            machines: machinesRef
        };

        setScrollTarget(refs[key]);
    };

    const handleScrollAfterOpen = () => {
        if (scrollTarget && scrollTarget.current) {
            window.scrollTo({
                top: scrollTarget.current.offsetTop + 100, // Adjust the offset if needed
                behavior: "smooth"
            });
            setScrollTarget(null); // Clear the target once scrolling is done
        }
    };

    useEffect(prepareFormatId, []);
    useEffect(loadFormat, [formatId, reload]);
    useEffect(calculateCompletedProcesses, [format]);
    useEffect(determineCurrentActiveKey, [completedProcesses]);
    useEffect(() => {
        scrollToAccordionItem(activeKey);
    }, [activeKey]);

    function title() {
        return <>
            {format?.formatStatus ?
                t("common.format") :
                t("common.add_new_format")
            }
        </>
    }


    return (
        <>
            <Loader loader={loader}/>
            {completedProcesses &&
                <CustomContainer
                    title={title()}
                    parent={
                        <LinkIconButton
                            model={models.format}
                            props={props}
                        />
                    }
                    subtitle={
                        <FormatHeader format={format}
                                      showManagement={true}

                                      formatId={formatId}/>
                    }
                >

                    <Col>

                        <CustomAccordion
                            defaultActiveKey={activeKey}
                            items={
                                [
                                    {
                                        title: t("forms.format_information"),
                                        completable: true,
                                        eventKey: "data",
                                        asButton: true,
                                        completed: completedProcesses.data,
                                        content:
                                            <FormatData
                                                formatId={formatId}
                                                format={format}
                                                setLoader={setLoader}
                                                onSaved={onSavedFormat}
                                            />
                                    },
                                    {
                                        title: t("common.machine_models"),
                                        completable: true,
                                        eventKey: "machines",
                                        asButton: true,
                                        enable: completedProcesses.data,
                                        completed: completedProcesses.machines,
                                        content:
                                            <>
                                                {format &&
                                                    <MachineStep
                                                        format={format}
                                                        reload={reload}
                                                        setReload={setReload}
                                                        setLoader={setLoader}
                                                        onSaved={loadFormat}
                                                    />}
                                            </>
                                    }
                                ]
                            }
                        />
                    </Col>
                </CustomContainer>
            }
        </>
    );
};

export default FormatPage;
